// ©2024 Austin App House. All rights reserved.
import React from 'react';
// removed MDBReact usage

const rowStyles = { marginTop: 20 };
const colStyles = { padding: '25px 0px 0px 15px' };

const PreviouslyWorkedProjectsSection = ({
  previouslyWorkedProjects = [],
}) => (
  <div className="container">
    <div className="row" style={rowStyles}>
      <div className="col-md-12" style={colStyles}>
        <h6>Previously Worked Projects</h6>
      </div>
    </div>
    <div className="row">
      <div className="col font-size-08">
        <ul>
          {
            previouslyWorkedProjects.map(projectName => (
              <li key={projectName}>
                {projectName}
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  </div>
);

export default PreviouslyWorkedProjectsSection;
